import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'simNao'
})
export class SimNaoPipe implements PipeTransform {

  transform(value: boolean | null | undefined): string {
    if (value === true) return 'Sim';
    if (value === false) return 'Não';
    return '-';
  }

}
